<template>
<v-layout align-center justify-center>
      <v-flex xs12 sm12 md12 lg12 xl9>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form @submit.prevent="createAssembly" @keydown="form.onKeydown($event)">
          <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('assembly.create-form.title') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 md3 lg4>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.assembly_type')"
                    :items="assembly_types"
                    :v-errors="errors"
                    :value.sync="form.assembly_type"
                    name="assembly_type"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''" row wrap>
                <v-flex xs6 md5 lg7>
                  <text-input
                    :form="form"
                    :label="$t('assembly.create-form.description')"
                    autocomplete="assembly_description"
                    :v-errors="errors"
                    :value.sync="form.description"
                    counter="30"
                    name="description"
                    v-validate="'required|max:30'"
                  ></text-input>
                </v-flex>
                <v-flex xs6 md4 lg5>
                  <text-input
                    :form="form"
                    :label="$t('assembly.create-form.responsible_name')"
                    autocomplete="assembly_responsible"
                    :v-errors="errors"
                    :value.sync="form.responsible_name"
                    counter="30"
                    name="responsible_name"
                    v-validate="'required|max:30'"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex md3 lg4>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.assembly_date')"
                    :v-errors="errors"
                    :value.sync="form.assembly_date"
                    name="assembly_date"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.assembly_time')"
                    :v-errors="errors"
                    :value.sync="form.assembly_time"
                    name="assembly_time"
                    format="24hr"
                    v-validate="'required'"
                  ></time-picker>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != 'virtual' && form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Asistencia</h3>
                </v-flex>
                <v-flex md3 lg3>
                    <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_attendance_percentage')"
                    :v-errors="errors"
                    :value.sync="form.min_attendance_percentage"
                    name="min_attendance_percentage"
                    v-validate="`${form.assembly_type != 'virtual' ? 'required' : ''}`"
                  ></number-input>
                </v-flex>
                <v-flex md3 lg3>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_attendance_percentage_asopaf')"
                    :v-errors="errors"
                    :value.sync="form.min_attendance_percentage_asopaf"
                    name="min_attendance_percentage_asopaf"
                    v-validate="`${form.assembly_type != 'virtual' ? 'required' : ''}`"
                  ></number-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type == 'virtual'">
                <v-flex sm4 md3 lg4>
                  <h3>Acceso virtual</h3>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <text-input
                    v-if="form.assembly_type == 'virtual'"
                    :form="form"
                    :label="$t('assembly.create-form.virtual_meet_link')"
                    autocomplete="assembly_virtual_meet_link"
                    :v-errors="errors"
                    :value.sync="form.virtual_meet_link"
                    counter="100"
                    name="virtual_meet_link"
                    v-validate="`${form.assembly_type == 'virtual' ? 'required|max:100' : ''}`"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Selección de documentos</h3>
                </v-flex>
                <v-flex xs12 md3 lg4>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.give_power_document_id')"
                    :items="documents_assembly"
                    :v-errors="errors"
                    :value.sync="form.give_power_document_id"
                    name="give_power_document_id"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
                <v-flex xs12 md3 lg4>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.take_power_document_id')"
                    :items="documents_assembly"
                    :v-errors="errors"
                    :value.sync="form.take_power_document_id"
                    name="take_power_document_id"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Poderes</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_limit')"
                    :hint="$t('assembly.create-form.hints.delegated_powers_limit')"
                    persistent-hint
                    autocomplete="delegated_powers_limit"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_limit"
                    name="delegated_powers_limit"
                    v-validate="'required'"
                  ></number-input>
                </v-flex>
                <v-flex xs6 md3 lg2>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_date_start')"
                    :max="form.assembly_date ? form.assembly_date : null"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_date_start"
                    name="delegated_powers_date_start"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
                <v-flex xs6 md3 lg2>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_date_limit')"
                    :min="form.delegated_powers_date_start ? form.delegated_powers_date_start : null"
                    :max="form.assembly_date ? form.assembly_date : null"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_date_limit"
                    name="delegated_powers_date_limit"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Primera convocatoria</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.first_call_time')"
                    :v-errors="errors"
                    :value.sync="form.first_call_time"
                    name="first_call_time"
                    format="24hr"
                    :min="form.assembly_time ? form.assembly_time : ''"
                    v-validate="'required'"
                  ></time-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_percentage_first_call')"
                    persistent-hint
                    autocomplete="min_percentage_first_call"
                    :v-errors="errors"
                    :value.sync="form.min_percentage_first_call"
                    name="min_percentage_first_call"
                    v-validate="'required|min_value:1|max_value:100'"
                  ></number-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Segunda convocatoria</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.second_call_time')"
                    :v-errors="errors"
                    :value.sync="form.second_call_time"
                    :min="form.first_call_time ? form.first_call_time : ''"
                    name="second_call_time"
                    v-validate="'required'"
                  ></time-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_percentage_second_call')"
                    min="1"
                    max="100"
                    persistent-hint
                    autocomplete="min_percentage_second_call"
                    :v-errors="errors"
                    :value.sync="form.min_percentage_second_call"
                    name="min_percentage_second_call"
                    v-validate="'required|min_value:1|max_value:100'"
                  ></number-input>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <submit-button  v-if="form.assembly_type != ''" :form="form" :label="$t('assembly.create-form.save-button')"></submit-button>
            <v-btn @click="$router.push({ name: 'assembly.show' });" :loading="form.busy">{{ $t('cancel') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from 'axios'
import Form from 'vform';
import NumberInput from '../../components/form/NumberInput.vue';
import TextInput from '../../components/form/DatePicker.vue';

export default {
  components: { 
    NumberInput, 
    'date-picker': TextInput 
  },
  name: 'assembly-create-view',

  data() {
    return {
      nowDate: new Date().toLocaleDateString('en-CA'),
      assembly_types: [
        { value: 'in_person', text: this.$t('assembly.assembly_types.in_person') },
        { value: 'virtual', text: this.$t('assembly.assembly_types.virtual') },
      ],
      form: new Form({
        assembly_date: '',
        assembly_time: '',
        assembly_type: '',
        responsible_id: '',
        responsible_name: '',
        description: '',
        delegated_powers_limit: '',
        delegated_powers_date_start: '',
        delegated_powers_date_limit: '',
        min_attendance_percentage: '',
        min_attendance_percentage_asopaf: '',
        virtual_meet_link: '',
        first_call_time: '',
        min_percentage_first_call: 50,
        second_call_time: '',
        min_percentage_second_call: '',
        give_power_document_id: '',
        take_power_document_id: '',  
      }),
      documents_assembly: [],
    }
  },
  created() {
    this.getDocumentsForAssembly()
  },
  methods: {
    async createAssembly() {
      if (await this.formHasErrors()) return

      const result = await this.form.post('/api/assembly')

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('assembly.create-form.stored-ok-text'),
          title: this.$t('assembly.create-form.stored-ok-title'),
          modal: true
        })
        // this.form.clear();
        // this.form.reset();
        this.$router.push({ name: 'assembly.show' });
      }
    },
    getDocumentsForAssembly(){
      let context = this
      context.isLoading = true
      axios.get(`/api/documents/get_documents_for_assembly`)
        .then(res => {
          res.data.forEach(document => {
            context.documents_assembly.push({ value: document.id, text: `${document.id} - ${document.description}` })
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/create.vue